import styled, { css } from 'styled-components';
import { defaultTextCss } from '../../common/mixins';
import { breakpoint } from '../../Themes/screensize';

const commonHeadingStyle = css`
  ${defaultTextCss};
  text-align: center;
  font-weight: bold;
`;

export const Heading1 = styled.h1`
  ${commonHeadingStyle};
  font-size: 2.5rem;
  line-height: 3rem;
  align-items: center;
  justify-content: center;
  @media (max-width: ${breakpoint.mobile}) {
    font-size: 2rem;
    line-height: 2.5rem;
  }
`;

export const Heading2 = styled.h2`
  ${commonHeadingStyle};
  font-size: 2rem;
  line-height: 2.5rem;
  @media (max-width: ${breakpoint.mobile}) {
    font-size: 1.75rem;
    line-height: 2.25rem;
  }
`;

export const Heading3 = styled.h3`
  ${commonHeadingStyle};
  font-size: 1.75rem;
  line-height: 2.25rem;
  display: flex;
  align-items: center;
  margin: 0;
  @media (max-width: ${breakpoint.mobile}) {
    font-size: 1.5rem;
    line-height: 2rem;
  }
`;

export const Heading4 = styled.h4`
  ${commonHeadingStyle};
  font-size: 1.5rem;
  line-height: 2rem;
  @media (max-width: ${breakpoint.mobile}) {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
`;

export const Heading5 = styled.h5`
  ${commonHeadingStyle};
  font-size: 1.25rem;
  line-height: 1.75rem;
  @media (max-width: ${breakpoint.mobile}) {
    font-size: 1rem;
    line-height: 1.5rem;
  }
`;
